import React, { useMemo } from 'react';
import { COMMUNITY_RANKING, SOCIAL_MEDALS, PROGRESS_SHOTS } from '../data/appData';
import { tryShareImageWithHashtags, copyTextToClipboard, downloadImage } from '../utils/share';

function RankingCard({ position, name, assists, medals, avatar }) {
  return (
    <div className="ranking-card">
      <div className="ranking-badge">#{position}</div>
      {avatar && <img className="ranking-avatar" src={avatar} alt={name} />}
      <div className="ranking-body">
        <h3 className="ranking-name">{name}</h3>
        <p className="ranking-meta">{assists} asistencias · {medals} medallas</p>
      </div>
    </div>
  );
}

function CommunityView() {
  const latestShot = useMemo(() => PROGRESS_SHOTS[PROGRESS_SHOTS.length - 1] || null, []);
  const INSTAGRAM_HASHTAGS = '#SportivosGym #MiProgreso #EntrenoSportivos';
  const INSTAGRAM_STORY_URL = 'https://www.instagram.com/create/story/';
  const INSTAGRAM_TAG_FEED = 'https://www.instagram.com/explore/tags/sportivosgym/';
  const REFERRAL_CODE = 'SPRT-JAVI23';

  const handleShareProgress = async () => {
    const imageUrl = latestShot?.image || '/logo-sportivos.png';
    const hashtags = `${INSTAGRAM_HASHTAGS} #SportivosCommunity`;

    const shared = await tryShareImageWithHashtags(imageUrl, hashtags);
    if (shared) {
      window.alert('¡Listo! Tu progreso se compartió con los hashtags de Sportivos.');
      return;
    }

    const copied = await copyTextToClipboard(`${hashtags}\n\nComparte tu avance con Sportivos 💪`);
    await downloadImage(imageUrl, 'sportivos-progreso.jpg');
    window.open(INSTAGRAM_STORY_URL, '_blank', 'noopener,noreferrer');
    window.alert(
      copied
        ? 'Abrimos Instagram Stories y copiamos los hashtags por ti. Solo pega y publica tu foto.'
        : `Abrimos Instagram Stories. Usa estos hashtags en tu historia:\n${hashtags}`,
    );
  };

  const handleViewMore = () => {
    window.open(INSTAGRAM_TAG_FEED, '_blank', 'noopener,noreferrer');
  };

  const handleCopyReferral = async () => {
    const copied = await copyTextToClipboard(`Únete con mi código ${REFERRAL_CODE} en Sportivos Gym.`);
    window.alert(
      copied
        ? 'Código copiado. ¡Pegalo en tu chat o historia y súmate al ranking!'
        : `No pudimos copiar automáticamente. Usa el código: ${REFERRAL_CODE}`,
    );
  };

  return (
    <div className="screen">
      <section className="section">
        <div className="community-hero">
          <div>
            <p className="eyebrow">Comunidad</p>
            <h1 className="title">Ranking Sportivos</h1>
            <p className="subtitle">Súmate al top compartiendo tus logros.</p>
          </div>
          <button type="button" className="pill-button pill-button-primary" onClick={handleShareProgress}>
            Compartir progreso
          </button>
        </div>
      </section>

      <section className="section">
        <header className="section-header">
          <h2 className="section-title">Top 4</h2>
          <button type="button" className="link-button" onClick={handleViewMore}>Ver más</button>
        </header>
        <div className="ranking-grid">
          {COMMUNITY_RANKING.map((member) => (
            <RankingCard key={member.id} {...member} />
          ))}
        </div>
      </section>

      <section className="section">
        <h2 className="section-title">Club de medallas</h2>
        <div className="social-medals">
          {SOCIAL_MEDALS.map(({ id, icon, label }) => (
            <span key={id} className="chip chip-light">
              <span aria-hidden="true">{icon}</span> {label}
            </span>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="share-card">
          <div>
            <h3 className="share-title">Embajador Sportivos</h3>
            <p className="share-text">Invita a tus amigos con el código</p>
            <div className="code-box">SPRT-JAVI23</div>
          </div>
          <button type="button" className="pill-button pill-button-primary" onClick={handleCopyReferral}>
            Copiar y compartir
          </button>
        </div>
      </section>
    </div>
  );
}

export default CommunityView;
